var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c(
        "div",
        {
          staticClass: "container map-container",
          class: { "map-container--zen-mode": _vm.isZenMode },
        },
        [
          _c(
            "div",
            {
              staticClass: "row",
              class: { h100: _vm.isZenMode },
              staticStyle: { "flex-wrap": "nowrap" },
            },
            [
              _c(
                "div",
                {
                  class: _vm.isZenMode
                    ? "col-lg-3 map-container__sidebar--zen-mode"
                    : "col-lg-3",
                },
                [
                  _c(
                    "div",
                    { staticClass: "map-container__sidebar" },
                    [
                      _c(
                        "div",
                        [
                          _c("h2", [_vm._v("Trasa i punkty na trasie")]),
                          _c("p", { staticClass: "mat16" }, [
                            _vm._v(" Klasyfikacja "),
                          ]),
                          _c("base-input-select", {
                            staticClass: "mat8 map-container__sidebar-select",
                            attrs: {
                              options: _vm.classifications,
                              "label-select": "namePl",
                              label: "Klasyfikacja",
                              error: _vm.errors.classification,
                            },
                            on: {
                              "update:error": function ($event) {
                                return _vm.$set(
                                  _vm.errors,
                                  "classification",
                                  $event
                                )
                              },
                            },
                            model: {
                              value: _vm.selectedClassification,
                              callback: function ($$v) {
                                _vm.selectedClassification = $$v
                              },
                              expression: "selectedClassification",
                            },
                          }),
                          _c("p", { staticClass: "mat16" }, [
                            _vm._v(" Dodaj trasę w pliku .gpx "),
                          ]),
                          _c("base-input-file", {
                            key: _vm.inputFileKey,
                            staticClass: "mat8",
                            class: {
                              "map-container__sidebar-file": !_vm.isZenMode,
                            },
                            attrs: {
                              hint: "Wybierz plik",
                              disabled: _vm.disabledInput,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.createGpx()
                              },
                              click: function ($event) {
                                _vm.disabledInput
                                  ? (_vm.errors.classification =
                                      "Wybierz klasyfikacje")
                                  : ""
                              },
                            },
                            model: {
                              value: _vm.trackFileList,
                              callback: function ($$v) {
                                _vm.trackFileList = $$v
                              },
                              expression: "trackFileList",
                            },
                          }),
                          _c(
                            "base-button",
                            {
                              staticClass: "mat16",
                              attrs: { btn2: "", icon: "fas fa-plus" },
                              on: {
                                click: function ($event) {
                                  return _vm.addPoint()
                                },
                              },
                            },
                            [_vm._v(" Dodaj punkt ")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" Tracking obłsugiwany przez: "),
                      _c("img", {
                        staticClass: "img-fluid mal24",
                        staticStyle: { "max-width": "200px" },
                        attrs: {
                          src: require("@/assets/images/logo-ap-white.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              path: `http://tracking.activeprogress.eu`,
                              tab: true,
                            })
                          },
                        },
                      }),
                      _c(
                        "base-button",
                        {
                          staticClass: "mat8",
                          class: { "status-btn--positive": _vm.shortName },
                          attrs: { btn2: "", icon: "fas fa-mobile-alt" },
                          on: {
                            click: function ($event) {
                              _vm.showPopupForActivationGPS =
                                !_vm.showPopupForActivationGPS
                            },
                          },
                        },
                        [
                          _vm._v(
                            " Mobile tracking: " +
                              _vm._s(_vm.shortName ? "aktywny" : "Aktywuj") +
                              " "
                          ),
                        ]
                      ),
                      _vm.showPopupForActivationGPS
                        ? _c("base-popup", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      !_vm.shortName
                                        ? _c("span", [
                                            _vm._v(
                                              " Aktywuj tracking dla urządzeń z aplikacją w telefonie. "
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              " Prefix dla Twoich urządzeń to: "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "mal8" },
                                              [
                                                _c("b", [
                                                  _vm._v(
                                                    _vm._s(_vm.shortName) + "-"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "subtitle",
                                  fn: function () {
                                    return [
                                      _vm.shortName
                                        ? _c("span", [
                                            _c("b", [
                                              _vm._v("Aktualny koszt:"),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.actualPrice) +
                                                " PLN "
                                            ),
                                            _c("br"),
                                          ])
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { class: { mat16: _vm.shortName } },
                                        [
                                          !_vm.shortName
                                            ? _c("span", [
                                                _c("b", [
                                                  _vm._v(
                                                    "Aktywujesz możliwość korzystania z telefonów jako urządzeń GPS."
                                                  ),
                                                ]),
                                              ])
                                            : _c("span", [
                                                _c("b", [_vm._v("Utworzono:")]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      `${_vm.devicesAvailable} urządzeń.`
                                                    ) +
                                                    " "
                                                ),
                                                _c("br"),
                                              ]),
                                          _vm.devicesAvailable > 0
                                            ? _c(
                                                "span",
                                                { staticClass: "buttonsRow" },
                                                [
                                                  _c(
                                                    "BaseButtonDownloadGPS",
                                                    {
                                                      staticClass: "mar15",
                                                      attrs: {
                                                        btn4: "",
                                                        url: `/gps/competition/${_vm.competition.id}/list`,
                                                        fileName: `${_vm.competition.name}-v${_vm.competition.id}-GPS_List.csv`,
                                                      },
                                                    },
                                                    [_vm._v(" Lista urządzeń ")]
                                                  ),
                                                  _c(
                                                    "base-button",
                                                    {
                                                      staticClass: "mal15",
                                                      attrs: {
                                                        icon: _vm.isCreating
                                                          ? "fas fa-spinner fa-spin"
                                                          : _vm.pplAssigned
                                                          ? "fas fa-check-circle"
                                                          : null,
                                                        btn4: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.assignExisting()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.isCreating
                                                              ? "Przypisuje..."
                                                              : _vm.pplAssigned
                                                              ? `Przypisano: ${_vm.pplAssigned}`
                                                              : "Przypisz istniejące"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          !_vm.shortName
                                            ? _c(
                                                "div",
                                                { staticClass: "mat16" },
                                                [
                                                  _c("base-input-text", {
                                                    staticClass: "mat8 bgc",
                                                    attrs: {
                                                      withoutErrorMessage: "",
                                                      hint: "Wybierz prefix, dla Twoich urządzeń.",
                                                      error: _vm.errors.prefix,
                                                    },
                                                    on: {
                                                      "update:error": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.errors,
                                                          "prefix",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.competitionPrefix,
                                                      callback: function ($$v) {
                                                        _vm.competitionPrefix =
                                                          $$v
                                                      },
                                                      expression:
                                                        "competitionPrefix",
                                                    },
                                                  }),
                                                  _c("b", [_vm._v("Uwaga:")]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: {
                                                        "c-negative":
                                                          _vm.errors.prefix,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.errors.prefix
                                                            ? _vm.errors.prefix
                                                            : "Wybór prefixu jest obowiązkowy"
                                                        ) + "."
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c("div", { staticClass: "mat16" }, [
                                            !_vm.shortName
                                              ? _c("span", [
                                                  _c("b", [
                                                    _vm._v(
                                                      "Aktywacja urządzeń"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " spowoduje, że urządzenia mobilne (telefon, tablet) będą mogły być używane jako urządzenia GPS do trackingu zawodników na tej imprezie. "
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _vm._e(),
                                            _c("span", [
                                              _c("b", [_vm._v("Wymagania:")]),
                                              _vm._v(
                                                " urządzenie musi mieć zainstalowaną aplikację "
                                              ),
                                              _c("b", [
                                                _vm._v("ActiveProgress"),
                                              ]),
                                              _vm._v(" lub "),
                                              _c("b", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "https://www.traccar.org/client/",
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [_vm._v("Traccar-Client")]
                                                ),
                                              ]),
                                              _vm._v(". "),
                                            ]),
                                            _c(
                                              "div",
                                              { staticClass: "mat16" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "http://dostartu.pl/files/web/konfiguracja_traccar.pdf",
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v("Instrukcja"),
                                                    ]),
                                                    _vm._v(
                                                      " poprawnego uruchomienia aplikacji "
                                                    ),
                                                    _c("b", [
                                                      _vm._v("Traccar-Client"),
                                                    ]),
                                                    _vm._v(". "),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "buttons",
                                  fn: function () {
                                    return [
                                      _c(
                                        "base-button",
                                        {
                                          staticClass: "mar15",
                                          attrs: { btn2: "" },
                                          on: {
                                            click: function ($event) {
                                              ;(_vm.showPopupForActivationGPS = false),
                                                (_vm.errors.prefix = "")
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.shortName
                                                  ? "zamknij"
                                                  : "anuluj"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "base-button",
                                        {
                                          staticClass: "mal15",
                                          attrs: { btn1: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.shortName
                                                ? ((_vm.showPopupForAddDevices = true),
                                                  (_vm.showPopupForActivationGPS = false))
                                                : _vm.mGPSactivate()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.shortName
                                                  ? "dodaj wiecej"
                                                  : "aktywuj"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2020641502
                            ),
                          })
                        : _vm._e(),
                      _vm.showPopupForAddDevices
                        ? _c("base-popup", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        " Dodaj wiecej urządzeń pomiarowych. "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        [
                                          _c("b", [_vm._v("Wybierz")]),
                                          _vm._v(" sposób dodania urządzeń. "),
                                          _c("base-input-radio", {
                                            attrs: {
                                              options: [
                                                {
                                                  value: "cls",
                                                  title: "classifications",
                                                },
                                                {
                                                  value: "numbers",
                                                  title: "Zakres numerów",
                                                },
                                              ],
                                            },
                                            model: {
                                              value: _vm.addBy,
                                              callback: function ($$v) {
                                                _vm.addBy = $$v
                                              },
                                              expression: "addBy",
                                            },
                                          }),
                                          _vm.addBy === "cls"
                                            ? _c(
                                                "div",
                                                { staticClass: "mat16" },
                                                [
                                                  _c("b", [_vm._v("Zaznacz")]),
                                                  _vm._v(
                                                    " klasyfikacje dla których chcesz dodać urządzenia. "
                                                  ),
                                                  _vm._l(
                                                    _vm.classifications,
                                                    function (cls, index) {
                                                      return _c(
                                                        "BaseInputCheckbox",
                                                        {
                                                          key: index,
                                                          staticClass: "mat8",
                                                          attrs: {
                                                            "checkbox-value":
                                                              _vm
                                                                .classifications[
                                                                index
                                                              ].checked,
                                                            name: `cls_ids[${index}]`,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .classifications[
                                                                index
                                                              ].checked,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .classifications[
                                                                  index
                                                                ],
                                                                "checked",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "classifications[index].checked",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(cls.namePl)
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _c("b", [_vm._v("Uwaga:")]),
                                                  _vm._v(
                                                    " Utworzone zostaną urządzenia jedynie dla zawodników, z przypisanymi numerami startowymi. "
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm.addBy === "numbers"
                                            ? _c(
                                                "div",
                                                { staticClass: "mat16" },
                                                [
                                                  _c("b", [_vm._v("Wybierz")]),
                                                  _vm._v(
                                                    " zakres numerów startowych, dla których chcesz dodać urządzenia. "
                                                  ),
                                                  _c("base-input-text", {
                                                    staticClass: "mat8 bgc",
                                                    attrs: {
                                                      type: "text",
                                                      label: "Od numeru",
                                                      hint: "Początkowy",
                                                      error:
                                                        _vm.errors.startNumber,
                                                    },
                                                    on: {
                                                      "update:error": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.errors,
                                                          "startNumber",
                                                          $event
                                                        )
                                                      },
                                                      input: function ($event) {
                                                        _vm.startNumber =
                                                          _vm.startNumber
                                                            .toString()
                                                            .replace(/\D/g, "")
                                                            .slice(0, 4)
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.startNumber,
                                                      callback: function ($$v) {
                                                        _vm.startNumber = $$v
                                                      },
                                                      expression: "startNumber",
                                                    },
                                                  }),
                                                  _c("base-input-text", {
                                                    staticClass: "mat8 bgc",
                                                    attrs: {
                                                      type: "text",
                                                      hint: "Końcowy",
                                                      label: "Do numeru",
                                                      error:
                                                        _vm.errors.endNumber,
                                                    },
                                                    on: {
                                                      "update:error": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.errors,
                                                          "endNumber",
                                                          $event
                                                        )
                                                      },
                                                      input: function ($event) {
                                                        _vm.endNumber =
                                                          _vm.endNumber
                                                            .toString()
                                                            .replace(/\D/g, "")
                                                            .slice(0, 4)
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.endNumber,
                                                      callback: function ($$v) {
                                                        _vm.endNumber = $$v
                                                      },
                                                      expression: "endNumber",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c("div", { staticClass: "mat16" }, [
                                            typeof _vm.additionalPrice ===
                                            "string"
                                              ? _c(
                                                  "span",
                                                  { staticClass: "c-negative" },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        " Przekroczony limit, jednocześnie można dodać max. 300 urządzeń. "
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _c("span", [
                                                    _c("b", [
                                                      _vm._v("Koszt aktywacji"),
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.newTrackers
                                                        ) +
                                                        " dodatkowych urządzeń:"
                                                    ),
                                                    _c("b", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.additionalPrice
                                                          ) +
                                                          " PLN"
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "c-negative",
                                                    },
                                                    [
                                                      _c("b", [
                                                        _vm._v("Koszt łączny"),
                                                      ]),
                                                      _vm._v(
                                                        " po aktywacji urządzeń:"
                                                      ),
                                                      _c("b", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.summaryPrice
                                                            ) +
                                                            " PLN"
                                                        ),
                                                      ]),
                                                      _c("br"),
                                                    ]
                                                  ),
                                                ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "buttons",
                                  fn: function () {
                                    return [
                                      _c(
                                        "base-button",
                                        {
                                          staticClass: "mar15",
                                          attrs: { btn2: "" },
                                          on: {
                                            click: function ($event) {
                                              ;(_vm.showPopupForAddDevices = false),
                                                (_vm.errors.prefix = "")
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.shortName
                                                  ? "zamknij"
                                                  : "anuluj"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "base-button",
                                        {
                                          staticClass: "mal15",
                                          attrs: {
                                            icon: _vm.isCreating
                                              ? "fas fa-spinner fa-spin"
                                              : null,
                                            disabled:
                                              _vm.isCreating ||
                                              !!_vm.errors.limitDevices,
                                            btn1: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              ;(_vm.isCreating = true),
                                                _vm.mGPSactivate()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(`+${_vm.newTrackers}`) +
                                              " Aktywuj "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1959451979
                            ),
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass: "mat16",
                              attrs: { btn2: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({
                                    path: `http://tracking.activeprogress.eu/${_vm.competition.name}-v${_vm.competition.id}`,
                                    tab: true,
                                  })
                                },
                              },
                            },
                            [_vm._v(" Twój tracking GPS ")]
                          ),
                          _c("base-button", {
                            staticClass: "mat16 size48",
                            attrs: { btn2: "", icon: "fas fa-user-cog" },
                            on: {
                              click: function ($event) {
                                return _vm.$router.push({
                                  path: `http://tracking.activeprogress.eu/${_vm.competition.name}-v${_vm.competition.id}?key=${_vm.competition.apiKey}`,
                                  tab: true,
                                })
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  class: _vm.isZenMode
                    ? "col-lg-9 map-container__map--zen-mode"
                    : "col-lg-9",
                },
                [
                  _c("map-competition", {
                    attrs: {
                      competition: _vm.competition,
                      classifications: _vm.classifications,
                      "selected-classification": _vm.selectedClassification,
                    },
                    on: {
                      "update:selectedClassification": function ($event) {
                        _vm.selectedClassification = $event
                      },
                      "update:selected-classification": function ($event) {
                        _vm.selectedClassification = $event
                      },
                      "delete-point": _vm.onDeletePointClick,
                      ready: function ($event) {
                        _vm.map = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.showPopupForRemove
                ? _c("base-popup", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._v(" Usuń punkt ")]
                          },
                          proxy: true,
                        },
                        {
                          key: "subtitle",
                          fn: function () {
                            return [
                              _c("b", [
                                _vm._v(
                                  "Czy na pewno, chcesz usunąć wybrany punkt?"
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "mat16" }, [
                                _vm._v(" Zostanie on usunięty z "),
                                _c("b", [_vm._v("wszystkich klasyfikacji")]),
                                _vm._v(
                                  " . Aby nie był wyświetlany w tej klasyfikacji, nie wybieraj żadnej kategorii w punkcie (nie wybrane Start, Meta, Pomiar, Punkt żywieniowy) "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "buttons",
                          fn: function () {
                            return [
                              _c(
                                "base-button",
                                {
                                  staticClass: "mar15",
                                  attrs: { btn2: "" },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.showPopupForRemove =
                                        !_vm.showPopupForRemove),
                                        (_vm.pointToDelete = null)
                                    },
                                  },
                                },
                                [_vm._v(" anuluj ")]
                              ),
                              _c(
                                "base-button",
                                {
                                  staticClass: "mal15",
                                  attrs: { btn1: "" },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.showPopupForRemove =
                                        !_vm.showPopupForRemove),
                                        _vm.deletePoint()
                                    },
                                  },
                                },
                                [_vm._v(" Usuń punkt ")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2438055189
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }